module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "structure"
  }), _vm._v(" "), _c('p', {
    staticClass: "Epi"
  }, [_c('span', {
    staticClass: "CharOverride-16"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Epi"
  }, [_c('span', {
    staticClass: "CharOverride-16"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Epi"
  }, [_c('span', {
    staticClass: "CharOverride-16"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Epi"
  }, [_c('span', {
    staticClass: "CharOverride-16"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Epi"
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("The key to everything is patience.")])]), _vm._v(" "), _c('p', {
    staticClass: "Epi"
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("You get the chicken by hatching")])]), _vm._v(" "), _c('p', {
    staticClass: "Epi"
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("the egg, not by smashing it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Attribut"
  }, [_vm._v("Arnold H. Glasgow")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18bab28e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThePowerOfPatience-3.vue
// module id = 69
// module chunks = 0